import React, { useState, useEffect, useContext } from 'react';
import {useTheme, makeStyles} from '@material-ui/core';
import InputField from '../components/inputField';
import { makeValidation, validateForm, isValidForm} from '../global/formHelper';
import globalContext from '../context/globalContext';
import API from '../global/api';
import Alert from '@material-ui/lab/Alert';
import ProgressButton from '../components/progressButton';
import {keyValueArray} from '../global/helpers';

const useStyles = makeStyles((theme) => ({
  detailsWrapper: {
    marginTop: 60,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 40
  }
}));

const ProfileTaxRateAdd = props => {

  const theme = useTheme();
  const classes = useStyles(theme);
  const context = useContext(globalContext);

  const [ form, setForm ] = useState({
    id_service_type: null,
    tax_rate: 0.00,
    tax_rate_label: ''
  });
  const [ serviceTypes, setServiceTypes ] = useState([]);
  const [ error, setError ] = useState(null);
  const [ loading, setLoading ] = useState(false);

  const [validation, setValidation] = useState(makeValidation([
    {
      name: 'id_service_type',
      display_name: 'Service Type',
      required: false
    },
    {
      name: 'tax_rate',
      display_name: 'Tax Rate (%)',
      required: true,
      additional: [
        {
          type: 'above',
          value: 0,
          error: 'Tax rate must be a percentage between 0 and 100%'
        },
        {
          type: 'below',
          value: 100,
          error: 'Tax rate must be a percentage between 0 and 100%'
        }
      ]
    },
    {
      name: 'tax_rate_label',
      display_name: 'Label',
      required: false
    }
  ]));

  const handleInputChange = e => {
    let newForm = {...form};
    newForm[e.target.name] = e.target.value;
    setForm(newForm);
  }

  const handleSubmit = () => {

    setError(null);
    setLoading(true);

    const valid = isValidForm(form, validation);
    setValidation(valid.validation);
    if(valid.isValid){

      //
      // Execute an api request and get the returned result
      //
      API.req(`/organisation/${context.profile.data.id_organisation}/taxrate`, 'POST', form).then(
        res => {
          setLoading(false);

          let newProfile = JSON.parse(JSON.stringify(context.profile.data));

          // What about the id??
          newProfile.tax_rates.push(res.result);
          context.profileUpdate(newProfile);
          if(typeof props.handleClose === 'function')
            props.handleClose();

          context.showSnack({message: 'Tax rate added!'}, 'success')

        },
        err => {
            setLoading(false);
            setError(typeof err === 'string' ? err : JSON.stringify(err))
        }
      )

    }
  }

  useEffect(() => {
    const newValidation = validateForm(form, validation);
    setValidation(newValidation);
  }, [form])

  useEffect(() => {
    
    if(typeof context.meta.data !== 'undefined' && typeof context.meta.data.service_types !== 'undefined')
      setServiceTypes(keyValueArray(context.meta.data.service_types, 'id_service_type', 'service_type'));

  }, [context.meta])

  return (
      <div className={classes.detailsWrapper}>

        {error && <Alert severity="error">{error}</Alert>}

        <div className={classes.form}>

          
          <div className="flex-row">
            <InputField name='id_service_type' validation={validation.id_service_type} value={form.id_service_type} handleChange={handleInputChange} hoverLabel={true} type="select" items={serviceTypes} />
          </div>

          <div className="flex-row">
            <InputField type="number" name='tax_rate' validation={validation.tax_rate} value={form.tax_rate} handleChange={handleInputChange} hoverLabel={true} />
          </div>

          <div className="flex-row">
            <InputField type="text" name='tax_rate_label' validation={validation.tax_rate_label} value={form.tax_rate_label} handleChange={handleInputChange} hoverLabel={true} />
          </div>

        </div>

        <div className="flex"></div>

        <div className="flex-row-end">
          <ProgressButton waiting={loading} variant="contained" onClick={handleSubmit}>Add</ProgressButton>
        </div>

      </div>
  );
}

export default ProfileTaxRateAdd;
